module.exports = __webpack_public_path__ + "static/img/block5.151e248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block5.png
// module id = E/00
// module chunks = 1